/*!
 * requires boot strap styles
 */
(function($){
    var defaultOptions = {text:'Button Text', url: 'https://', font: 14, width: 150, height: 32, background: '#FF9000', foreground: '#FFFFFF'};

    // Define button for display on toolbar. Make it available in the buttons option.
    $.Editable.commands = $.extend($.Editable.commands, {
        insertLinkButton: {
          title: 'Insert Link Button',
          icon: 'fa fa-square',
          callback: function (cmd, val, param){
            if (!this.selectionInEditor()) {
                this.$element.focus(); // Focus on editor if it's not.
            }

            this.insertLinkButton(val, param);
          },
          undo: true
        }
    });

    $.Editable.prototype.insertLinkButton = function(){
        // Close image mode.
        // this.closeImageMode();
        // this.imageMode = false;

        this.showInsertLinkButton();
        this.saveSelectionByMarkers();

        if (!this.options.inlineMode) {
          this.positionPopup('insertLinkButton');
        }
    };

    $.Editable.prototype.showInsertLinkButton = function($linkButton){
        this.hidePopups();
        this.showLinkButtonWrapper($linkButton);
    };

    $.Editable.prototype.showLinkButtonWrapper = function($linkButton){
        // set values for editor inputs
        if(this.$linkButton_wrapper){
            // if link button exist then this is a current button
            if($linkButton){
                var $buttonCell = $linkButton.find('tbody tr:first td:first');
                var $buttonAnchor = $buttonCell.find('a:first');
                var width = $buttonCell.css('width').replace('px', '');
                var height = $buttonCell.css('height').replace('px', '');
                var font = $buttonCell.css('font-size').replace('px', '');
                var foreground = $.Editable.RGBToHex($buttonCell.css('color'));
                var background = $.Editable.RGBToHex($buttonCell.css('background-color'));

                this.$linkButton_wrapper.find('input#f-ilb-buttonText-' + this._id).val($linkButton.text());
                this.$linkButton_wrapper.find('input#f-ilb-buttonUrl-' + this._id).val($buttonAnchor.attr('href'));
                this.$linkButton_wrapper.find('input#f-ilb-buttonWidth-' + this._id).val(width);
                this.$linkButton_wrapper.find('input#f-ilb-buttonHeight-' + this._id).val(height);
                this.$linkButton_wrapper.find('input#f-ilb-buttonForeground-' + this._id).val(foreground);
                this.$linkButton_wrapper.find('input#f-ilb-buttonBackground-' + this._id).val(background);
                this.$linkButton_wrapper.find('input#f-ilb-buttonFont-' + this._id).val(font);
                this.$linkButton_wrapper.data('ilb-button', $linkButton);
            } else {
                this.$linkButton_wrapper.find('input#f-ilb-buttonText-' + this._id).val('');
                this.$linkButton_wrapper.find('input#f-ilb-buttonUrl-' + this._id).val('');
                this.$linkButton_wrapper.find('input#f-ilb-buttonWidth-' + this._id).val(defaultOptions.width);
                this.$linkButton_wrapper.find('input#f-ilb-buttonHeight-' + this._id).val(defaultOptions.height);
                this.$linkButton_wrapper.find('input#f-ilb-buttonForeground-' + this._id).val(defaultOptions.foreground);
                this.$linkButton_wrapper.find('input#f-ilb-buttonBackground-' + this._id).val(defaultOptions.background);
                this.$linkButton_wrapper.find('input#f-ilb-buttonFont-' + this._id).val(defaultOptions.font);

                this.$linkButton_wrapper.removeData('ilb-button');
            }

            this.$linkButton_wrapper.show();
        }
    };

    $.Editable.prototype.hideLinkButtonWrapper = function(){
        if(this.$linkButton_wrapper){
            this.$linkButton_wrapper.hide();
            this.$linkButton_wrapper.find('input').blur();

            // clear any stored $linkButton data
            this.$linkButton_wrapper.removeData('ilb-button');
        }
    };

    $.Editable.prototype.writeInsertLinkButton = function($linkButton, options){
        var buttonData = this.sanitizeLinkButtonValues(options);
        var dimensionStyle = 'width:' + buttonData.width + 'px;height:' + buttonData.height + 'px;';
        var fontStyle = 'font-size:' + buttonData.font + 'px;';
        var colorsStyle = 'color:' + buttonData.foreground + ';background-color:' + buttonData.background + ';';

        // use table style for proper formatting in Outlook
        var html = '<table class="f-ilb-anchor-table" contenteditable="false" cellpadding="0" cellspacing="0" border="0" style="' + dimensionStyle + 'border-collapse:collapse;vertical-align:middle;">';
        html += '<tbody><tr>';
        html += '<td border="0" valign="middle" style="' + dimensionStyle + colorsStyle + fontStyle + 'border-radius:20px;border:0;vertical-align:middle;text-align:center;">';
        html += '<div style="border-radius:20px;margin:0;padding:0;mso-table-lspace:0;mso-table-rspace:0;">';
        html += '<a class="f-ilb-anchor" border="0" href="' + buttonData.url + '" style="' + colorsStyle + 'border:0;font-family:Arial,Helvetica,sans-serif;mso-table-lspace:0;mso-table-rspace:0;text-decoration:none;" contenteditable="false">' + buttonData.text + '</a>';
        html += '</div></td></tr></tbody></table>';

        // editing already existing link button
        if($linkButton){
            $linkButton.replaceWith(html);
        } else {
            // insert new button
            this.restoreSelectionByMarkers();
            this.focus();
            this.insertHTML(html);
        }

        // hide controls
        this.hide();
        this.hideLinkButtonWrapper();

        // save in undo stack
        // this.restoreSelectionByMarkers();
        this.saveUndoStep();

        // focus after changes
        this.focus();
    };

    $.Editable.prototype.linkButtonHTML = function(){
        // ilb = insert link button
        var html = '<div class="froala-popup froala-link-button-popup" style="display: none;">';
        html += '<h4><span data-text="true">Insert Link Button</span><i title="Cancel" class="fa fa-times" id="f-link-button-close-' + this._id + '"></i></h4>';

        // button text
        html += '<div class="f-popup-line"><label for="f-ilb-buttonText-' + this._id + '"><span data-text="true">Text</span>: </label><input type="text" placeholder="Button Text" id="f-ilb-buttonText-' + this._id + '"/></div>';

        // button url
        html += '<div class="f-popup-line"><label for="f-ilb-buttonUrl-' + this._id + '"><span data-text="true">Enter URL</span>: </label><input type="text" placeholder="http://www.example.com" id="f-ilb-buttonUrl-' + this._id + '"/></div>';

        // dimensions
        html += '<div class="f-popup-line"><label for="f-ilb-buttonHeight-' + this._id + '"><span data-text="true">Height</span>: </label><input min="1" max="999" value="32" type="number" id="f-ilb-buttonHeight-' + this._id + '"/>';
        html += '<label for="f-ilb-buttonWidth-' + this._id + '"><span data-text="true">Width</span>: </label><input type="number" min="1" max="999" value="150" id="f-ilb-buttonWidth-' + this._id + '"/>';
        html += '</div>';

        // colors
        html += '<div class="f-popup-line"><label for="f-ilb-buttonForeground-' + this._id + '"><span data-text="true">Text Color</span>: </label><input type="color" value="#FFFFFF" id="f-ilb-buttonForeground-' + this._id + '"/>';
        html += '<label for="f-ilb-buttonBackground-' + this._id + '"><span data-text="true">Background</span>: </label><input type="color" value="#FF9000" id="f-ilb-buttonBackground-' + this._id + '"/>';
        html += '</div>';

        // font size
        html += '<div class="f-popup-line"><label for="f-ilb-buttonFont-' + this._id + '"><span data-text="true">Font Size</span>: </label><input min="1" max="52" value="14" type="number" id="f-ilb-buttonFont-' + this._id + '"/></div>';

        // OK button
        html += '<div class="f-popup-line"><button data-text="true" type="button" class="fr-p-bttn f-ok f-submit pull-right" id="f-ilb-ok-' + this._id + '">OK</button></div>';

        // end popup
        html += '</div>';

        return html;
    };

    // Register insertLinkButton plugin
    $.Editable.prototype.buildInsertLinkButton = function(){
        // Add file wrapper to editor.
        this.$linkButton_wrapper = $(this.linkButtonHTML());
        this.$popup_editor.append(this.$linkButton_wrapper);

        this.addListener('hidePopups', $.proxy(function(){
          this.hideLinkButtonWrapper();
        }, this));

        // Add events to html elements in wrapper
        // close popup
        this.$linkButton_wrapper.on(this.mouseup, 'i#f-link-button-close-' + this._id, $.proxy(function(e){
            e.stopPropagation();
            e.preventDefault();

            this.$bttn_wrapper.show();
            this.hideLinkButtonWrapper();
            this.restoreSelection();
            this.focus();
            this.hide();
        }, this));

        // ok button
        this.$linkButton_wrapper.on('click', 'button#f-ilb-ok-' + this._id, $.proxy(function(){
            var $inputButtonText = this.$linkButton_wrapper.find('input#f-ilb-buttonText-' + this._id);
            var $inputButtonUrl = this.$linkButton_wrapper.find('input#f-ilb-buttonUrl-' + this._id);
            var $inputButtonFont = this.$linkButton_wrapper.find('input#f-ilb-buttonFont-' + this._id);
            var $inputButtonHeight = this.$linkButton_wrapper.find('input#f-ilb-buttonHeight-' + this._id);
            var $inputButtonWidth = this.$linkButton_wrapper.find('input#f-ilb-buttonWidth-' + this._id);
            var $inputButtonForeground = this.$linkButton_wrapper.find('input#f-ilb-buttonForeground-' + this._id);
            var $inputButtonBackground = this.$linkButton_wrapper.find('input#f-ilb-buttonBackground-' + this._id);
            var $linkButton = this.$linkButton_wrapper.data('ilb-button');

            var options = {
                text: $inputButtonText.val(),
                url: $inputButtonUrl.val(),
                font: $inputButtonFont.val(),
                height: $inputButtonHeight.val(),
                width: $inputButtonWidth.val(),
                foreground: $inputButtonForeground.val(),
                background: $inputButtonBackground.val()
            };

            this.writeInsertLinkButton($linkButton, options);
        }, this));

        this.$linkButton_wrapper.on('click', function(e){
            e.stopPropagation();
        });

        this.$linkButton_wrapper.on('click', '*', function(e){
            e.stopPropagation();
        });
    };

    $.Editable.prototype.sanitizeLinkButtonValues = function(options){
        // TODO: DON'T OVERRIDE URL SANITIZE METHOD UNTIL HERE ONLY IF NEEDED
        return {
            text: (options.text && options.text !== '') ? options.text : defaultOptions.text,
            url: (options.url && options.url !== '') ? options.url : defaultOptions.url,
            font: (options.font && options.font !== '') ? options.font : defaultOptions.font,
            height: (options.height && options.height !== '') ? options.height : defaultOptions.height,
            width: (options.width && options.width !== '') ? options.width : defaultOptions.width,
            foreground: (options.foreground && options.foreground !== '') ? options.foreground : defaultOptions.foreground,
            background: (options.background && options.background !== '') ? options.background : defaultOptions.background
        }
    }

    $.Editable.prototype.initInsertLinkButtonEvents = function(){
        // keep reference to Editable
        var editable = this;
        var selector = 'a.f-ilb-anchor';
        var tableSelector = 'table.f-ilb-anchor-table';
        var buttonTextPlaceholder = 'Button Text';
        var buttonLinkPlaceholder = 'http://example.com';
        if ($.Editable.LANGS[this.options.language]) {
            buttonTextPlaceholder = $.Editable.LANGS[this.options.language].translation[buttonTextPlaceholder];
            buttonLinkPlaceholder = $.Editable.LANGS[this.options.language].translation[buttonLinkPlaceholder];

        }
        this.$linkButton_wrapper.find('input#f-ilb-buttonText-' + this._id).attr('placeholder', buttonTextPlaceholder);
        this.$linkButton_wrapper.find('input#f-ilb-buttonUrl-' + this._id).attr('placeholder', buttonLinkPlaceholder);

        var cancelLinkButton_click = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };

        var linkButton_click = function(e){
            var $linkButton = $(this);

            if($linkButton.hasClass('f-ilb-anchor')){
                $linkButton = $linkButton.closest(tableSelector);
            }

            e.stopPropagation();
            e.preventDefault();

            // Show editor
            editable.showByCoordinates($linkButton.offset().left + $linkButton.outerWidth() / 2, $linkButton.offset().top + (parseInt($linkButton.css('padding-top'), 10) || 0) + $linkButton.height());

            // Show link button wrapper
            editable.showInsertLinkButton($linkButton);
        };

        // Click on a link button
        if(!editable.isLink){
            if (editable.iOS()){
                editable.$element.on('touchstart', tableSelector, cancelLinkButton_click);
                editable.$element.on('touchend', tableSelector, linkButton_click);
                editable.$element.on('touchstart', selector, cancelLinkButton_click);
                editable.$element.on('touchend', selector, linkButton_click);
            } else {
                editable.$element.on('click', tableSelector, linkButton_click);
                editable.$element.on('click', tableSelector, cancelLinkButton_click);
                editable.$element.on('click', selector, linkButton_click);
                editable.$element.on('click', selector, cancelLinkButton_click);
            }
        } else {
            if (editable.iOS()) {
                editable.$element.on('touchstart', tableSelector, cancelLinkButton_click);
                editable.$element.on('touchend', tableSelector, linkButton_click);
                editable.$element.on('touchstart', cancelLinkButton_click);
                editable.$element.on('touchend', linkButton_click);
            } else {
                editable.$element.on('click', linkButton_click);
            }
        }
    };

    $.Editable.prototype.initInsertLinkButton = function(){
        this.buildInsertLinkButton();
        this.initInsertLinkButtonEvents();
    };

    $.Editable.initializers.push($.Editable.prototype.initInsertLinkButton);
})(jQuery);



